var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('FrmManageEquipments',{attrs:{"show-select":"true","selected-equipment":_vm.selectedEquipments},on:{"item-selected":_vm.selectedCallback}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }